import axiosInstance from "./axios-instance";
import { isMutationSuccess } from "./cache-utils";
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === "undefined") {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem("accountId") || "0");
};

const withScopedAccountId = (payload: any) => {
  if (!payload || typeof payload !== "object") {
    return payload;
  }
  const scopedAccountId = getScopedAccountId(payload.accountId);
  if (!(scopedAccountId > 0)) {
    return payload;
  }
  return {
    ...payload,
    accountId: scopedAccountId,
  };
};

const normalizeHardwareMarkup = (value: any) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const addDraperyOrderHardware = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const newPayload = {
      ...scopedPayload,
      hardwareItem: scopedPayload.hardwareItem === '' ? null : scopedPayload.hardwareItem,
      hardwareQuantity:
        scopedPayload.hardwareQuantity === '' ? null : parseFloat(scopedPayload.hardwareQuantity),
      hardwareMarkup: normalizeHardwareMarkup(scopedPayload.hardwareMarkup),
      hardwareCustomerFacingPrice:
        scopedPayload.hardwareCustomerFacingPrice === ''
          ? null
          : parseFloat(scopedPayload.hardwareCustomerFacingPrice),
    };
    const response = await axiosInstance.post<any>('draperyOrderHardware/new', newPayload)
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(newPayload, response.data), resolveClientId(newPayload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
const editDraperyOrderHardware = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const newPayload = {
      ...scopedPayload,
      hardwareItem: scopedPayload.hardwareItem === '' ? null : scopedPayload.hardwareItem,
      hardwareQuantity:
        scopedPayload.hardwareQuantity === '' ? null : parseFloat(scopedPayload.hardwareQuantity),
      hardwareMarkup: normalizeHardwareMarkup(scopedPayload.hardwareMarkup),
      hardwareCustomerFacingPrice:
        scopedPayload.hardwareCustomerFacingPrice === ''
          ? null
          : parseFloat(scopedPayload.hardwareCustomerFacingPrice),
    };
    const response = await axiosInstance.post<any>('draperyOrderHardware/edit', newPayload)
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(newPayload, response.data), resolveClientId(newPayload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export {
  addDraperyOrderHardware,
  editDraperyOrderHardware,
}
